import DivisionDate from '../division/divisionDate';

function DivisionDatePage() {
  return (
    <DivisionDate />
  );
}

export default DivisionDatePage;
